import React from 'react';
import { IPageLaunchParams, makeComponent } from "./types";
import { RenderEvent } from './RenderEvent';


export const AppSqlPageContainer = makeComponent(class extends React.Component<{event?:RenderEvent,$elem?:any,page?:IPageLaunchParams,layer?:any}>{
    
    render(){
        let page = this.props.page;
        let pageName = page.name;
        let i = pageName.lastIndexOf("/");
        if (i != -1){
            pageName = pageName.substring(i + 1);
        }
        let params = {};
        if (page.props){
            for(let key in page.props){
                if (key[0] == '@'){
                    params[key] = page.props[key];
                }
            }
        }
        return React.createElement("sqx-frame",{src:pageName,"sqx:params":JSON.stringify(params),layer:this.props.layer});
    }
});


